<template>
  <div class="process-designer">
    <div class="scale">
      <a-button icon="plus" size="small" :disabled="scale >= 150" shape="circle" @click="scale += 10" />
      <span>{{ scale }}%</span>
      <a-button icon="minus" size="small" :disabled="scale <= 40" shape="circle" @click="scale -= 10" />
    </div>
    <div class="design" :style="'transform: scale(' + scale / 100 + ');'">
      <process-tree ref="process-tree" @selectedNode="nodeSelected" />
    </div>
    <a-drawer :visible="visible" :width="600" @close="visible = false">
      <div slot="title">
        <a-input v-show="showInput" v-model="selectedNode.name" style="width: 300px" @blur="showInput = false" />
        <a-button v-show="!showInput" type="link" style="font-size: medium" @click="showInput = true">
          {{ selectedNode.name }}
          <a-icon type="edit" style="margin-right: 10px" />
        </a-button>
      </div>
      <div class="node-config-content">
        <node-form />
      </div>
    </a-drawer>
  </div>
</template>

<script>
import NodeForm from '@/pages/system/workflow/components/NodeForm';
import ProcessTree from '@/pages/system/workflow/components/ProcessTree';

export default {
  components: { ProcessTree, NodeForm },
  data() {
    return {
      scale: 100,
      selected: {},
      visible: false,
      showInput: false,
      showConfig: false
    };
  },
  computed: {
    selectedNode() {
      return this.$store.state.selectedNode;
    }
  },
  methods: {
    validate() {
      return this.$refs['process-tree'].validateProcess();
    },
    nodeSelected(node) {
      this.visible = true;
      this.showInput = false;
    }
  }
};
</script>

<style lang="less" scoped>
.process-designer {
  height: calc(~'100vh - 198px');
  overflow-y: auto;
}
.design {
  margin-top: 10px;
  display: flex;
  transform-origin: 50% 0px 0px;
}

.scale {
  z-index: 999;
  position: fixed;
  top: 132px;
  right: 16px;

  span {
    margin: 0 10px;
    font-size: 14px;
    color: #7a7a7a;
    width: 50px;
  }
}

.node-config-content {
  padding: 0 16px 16px;
}

/deep/ .el-drawer__body {
  overflow-y: auto;
}
</style>
